import { arrayGetSet, createAccessors } from 'z3k-parser/lib/accessories';
import { isFlagSet, setFlag } from 'z3k-parser/lib/flags';
export var ThreewayTapState;
(function (ThreewayTapState) {
    ThreewayTapState[ThreewayTapState["AT_REST"] = 0] = "AT_REST";
    ThreewayTapState[ThreewayTapState["OPENING"] = 1] = "OPENING";
    ThreewayTapState[ThreewayTapState["CLOSING"] = 2] = "CLOSING";
    ThreewayTapState[ThreewayTapState["OPEN"] = 3] = "OPEN";
    ThreewayTapState[ThreewayTapState["CLOSE"] = 4] = "CLOSE";
})(ThreewayTapState || (ThreewayTapState = {}));
export var ThreewayTap;
(function (ThreewayTap) {
    let Direction;
    (function (Direction) {
        Direction[Direction["idle"] = 0] = "idle";
        Direction[Direction["open_run"] = 1] = "open_run";
        Direction[Direction["close_run"] = 2] = "close_run";
    })(Direction = ThreewayTap.Direction || (ThreewayTap.Direction = {}));
    let Flags;
    (function (Flags) {
        Flags[Flags["TWO_WAY_TAP_FLAG"] = 1] = "TWO_WAY_TAP_FLAG";
        Flags[Flags["INVERSE_MODE"] = 2] = "INVERSE_MODE";
        Flags[Flags["IS_IN_NON_STOP_MODE_FLAG"] = 4] = "IS_IN_NON_STOP_MODE_FLAG";
        Flags[Flags["CLOSE_IF_EMERGENCY"] = 8] = "CLOSE_IF_EMERGENCY";
    })(Flags = ThreewayTap.Flags || (ThreewayTap.Flags = {}));
    ThreewayTap.get = createAccessors(arrayGetSet('threeway_taps'), {
        name: 'Кран',
        physical_output1: -1,
        physical_output2: -1,
        step_time: 2,
        closing_time: 120,
        coefficient: 0,
        setting_register: 0,
        step_period: 10,
    });
    function isTwoWay(tap) {
        return isFlagSet(tap, Flags.TWO_WAY_TAP_FLAG);
    }
    ThreewayTap.isTwoWay = isTwoWay;
    function setTwoWayTap(tap, is_two_way) {
        return setFlag(tap, Flags.TWO_WAY_TAP_FLAG, is_two_way);
    }
    ThreewayTap.setTwoWayTap = setTwoWayTap;
    function changeThreeWayTapType(tap, is_two_way) {
        return {
            ...setTwoWayTap(tap, is_two_way),
            closing_time: is_two_way ? 10 : tap.closing_time,
            physical_output1: is_two_way ? -1 : tap.physical_output1,
        };
    }
    ThreewayTap.changeThreeWayTapType = changeThreeWayTapType;
    function isInverse(threeway_tap) {
        if (!threeway_tap?.setting_register)
            return false;
        return isFlagSet(threeway_tap, Flags.INVERSE_MODE);
    }
    ThreewayTap.isInverse = isInverse;
})(ThreewayTap || (ThreewayTap = {}));
